export default "__VITE_ASSET__BD8kT2sl__"